import designTokens from '@customink/design-tokens/build/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiMenuItem: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        '&.Mui-focusVisible': {
                            backgroundColor: designTokens.color.gray.accent.value,
                        },
                        backgroundColor: designTokens.color.gray.accent.value,
                        '&:hover': {
                            backgroundColor: designTokens.color.gray.accent.value,
                        },
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=menuTheme.js.map